import {useRef, useEffect} from 'react';
import Modal from '@cvent/carina/components/Modal';
import {LoadingSpinner} from '@cvent/carina/components/LoadingSpinner';

const PaymentProcessing = () => {
  const headerRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headerRef.current?.focus();
  }, []);

  return (
    <Modal
      isOpen
      format="sm"
      testID="payment-processing-modal"
      aria-labelledby="payment-processing-title"
    >
      <div className="flex flex-col items-center px-6 py-6 pt-4">
        <h1
          id="payment-processing-title"
          ref={headerRef}
          tabIndex={0}
          className="text-[24px] font-bold leading-[var(--carina-line-height-tight)] text-[#1c2430] self-start mb-4 outline-2 outline-offset-2 outline-transparent focus-visible:outline focus-visible:outline-primary-50"
        >
          Payment processing
        </h1>
        <p className="text-sm leading-[var(--carina-line-height-normal)] text-[#69727f] self-start m-0">
          Stay on this page to avoid disrupting the payment process.
        </p>
        <LoadingSpinner size="md" text="" className="mb-0" />
      </div>
    </Modal>
  );
};

export default PaymentProcessing;
